import { render } from "./Storage.vue?vue&type=template&id=6cb59272&scoped=true"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"

import "./Storage.vue?vue&type=style&index=0&id=6cb59272&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb59272"]])

export default __exports__